export default () => {
  const { REACT_APP_LOCATION } = process.env;
  /**
   * If some location need the footer, just added
   * to the locations array
   */
  const locations = ['houston', 'dallas_fortworth'];

  if (locations.includes(REACT_APP_LOCATION)) {
    return true;
  }
  return false;
};
